import React from "react";

import StopTime from "@busbud/design-system-components/dist/StopTime";

import { useAppContext } from "@app/helpers/hooks";

import type { IntermediateStop as IntermediateStopType } from "../../types";

import { useStyles } from "./intermediate-stop.styles";
import { getFormattedDuration } from "../../../../helpers/duration";
import { getMomentDurationInMinutes } from "../../../../helpers/time";
import { CheckpointLayout } from "../../checkpoint-layout";
import { CheckpointPath } from "../../checkpoint-path";
import { CheckpointTime } from "../../checkpoint-time";
import { LocationInfo } from "../../location-info";

interface Props {
  stop: IntermediateStopType;
  day_difference: number;
}

export const IntermediateStop: React.FC<Props> = ({ day_difference, stop }) => {
  const { classes } = useStyles();
  const { translator } = useAppContext();

  if (!stop.arrival_time) {
    return null;
  }

  const duration = getMomentDurationInMinutes(stop.duration);
  const formatted_duration = getFormattedDuration(duration, translator);

  return (
    <CheckpointLayout
      slot_start={
        <CheckpointTime
          value={stop.arrival_time}
          day_difference={day_difference}
          variant="minor"
        />
      }
      slot_middle={<CheckpointPath variant="minor" />}
      slot_end={
        <LocationInfo
          title={stop.departure_name}
          subtitle={
            stop.duration > 0 && (
              <div className={classes.stopTime}>
                {/*
                  TODO: use as a `time` tag, apply `display: "block"` style,
                  pass the `dateTime` attribute after fixing the component in
                  https://github.com/busbud/design-system/issues/1111
                */}
                <StopTime durationMinutes={duration.asMinutes()}>
                  {formatted_duration}
                </StopTime>
              </div>
            )
          }
        />
      }
    />
  );
};
